import { Component, OnInit, OnDestroy, ViewChild, AfterViewInit, ViewChildren, HostListener, ElementRef } from '@angular/core';
import { MatDialog, MatSelect } from '@angular/material';
import { DatePipe } from '@angular/common';

import { BranchService } from 'src/app/core/services/branch.service';
import { CommonService } from 'src/app/core/services/common.service';
import { NotificationService } from 'src/app/core/services/notification.service';
import { Subscription, ReplaySubject, Subject } from 'rxjs';
import { WarningComponent } from 'src/app/shared/components/warning/warning.component';
import { Router, ActivatedRoute } from '@angular/router';
import { NgForm, FormControl } from '@angular/forms';
import { UploadMultiFileComponent } from 'src/app/shared/components/upload-multi-file/upload-multi-file.component';
import { BaseComponent } from 'src/app/shared/components/base/base.component';
import { DeactivationGuarded } from 'src/app/core/guards/confirm-deactivate.guard';
import { map, first, takeUntil } from 'rxjs/operators';
import { BreadcrumbsService } from 'src/app/shared/components/breadcrumbs/breadcrumbs.service';
import { Message } from 'src/app/core/class/message';
import { ToastrService } from 'ngx-toastr';
import Utils from 'src/app/core/services/app-utils';
import { CustomerFilterLanguage } from 'src/app/core/class/customer-filter-language';
import { Common } from '../../../../../../core/constants/common';

@Component({
  selector: 'app-update-branch',
  templateUrl: './update-branch.component.html'
})
export class UpdateBranchComponent extends BaseComponent implements OnInit, AfterViewInit, OnDestroy, DeactivationGuarded {
  // set max date for birthday
  maxDate = new Date();
  minDate = new Date(1899, 12, 1);
  oldBranchName;
  @ViewChild(UploadMultiFileComponent, { read: UploadMultiFileComponent, static: false }) uploadMultiFileComponent;
  @ViewChild('certificationTypeSelect', { static: false }) certificationTypeSelect: MatSelect;
  @ViewChild('representativeCertificateSelect', { static: false }) representativeCertificateSelect: MatSelect;
  @ViewChild('citySelect', { static: false }) citySelect: MatSelect;
  @ViewChild('districtSelect', { static: false }) districtSelect: MatSelect;
  @ViewChild('wardSelect', { static: false }) wardSelect: MatSelect;
  @ViewChild('sexSelect1', { static: false }) sexSelect1: MatSelect;

  branch = {
    adminUser: '',
    id: null,
    parentId: localStorage.getItem('enterpriseId'),
    tenantId: localStorage.getItem('tenantId'),
    name: '',
    foreignName: '',
    abbreviation: '',
    taxCode: '',
    phone: '',
    fax: '',
    primaryEmail: '',
    email: '',
    certificateId: null,
    certificateNo: '',
    issuedDate: '',
    issuedAt: '',
    accountNumber: '',
    bankName: '',
    bankBranch: '',
    representative: '',
    position: '',
    representativeCertificateId: null,
    representativeCertificateNo: '',
    representativeIssuedDate: '',
    representativeIssuedOn: '',
    birthday: '',
    sex: null,
    businessType: null,
    enterpriseType: null,
    status: null,
    isDeleted: null,
    attachments: [],
    parentName: '',
    version: '',
    addresses: [
      {
        cityId: null,
        wardId: null,
        districtId: null,
        address: ''
      }
    ]
  };
  checkFocus = true;
  cities: comboBox[] = [];
  districts: districtsComboBox[] = [];
  selectedDistricts: districtsComboBox[] = [];
  wards: wardsCombobox[] = [];
  selectWards: wardsCombobox[] = [];
  show = true;

  searchtenantId: '';
  searchPage: number;
  searchPageSize: number;
  searchParentId: '';
  searchKeyword: '';
  searchStatus: [];

  certificateType: comboBox[] = [];
  representativeCertificateType: comboBox[] = [];
  maxLengthPhone = Common.MAX_LENGTH_PHONE;

  certificateTypeFilterCtrl: FormControl = new FormControl();
  representativeCertificateTypeFilterCtrl: FormControl = new FormControl();
  cityFilterCtrl: FormControl = new FormControl();
  districtsFilterCtrl: FormControl = new FormControl();
  wardFilterCtrl: FormControl = new FormControl();

  public filteredWard: ReplaySubject<wardsCombobox[]> = new ReplaySubject<wardsCombobox[]>(1);
  public filteredDistricts: ReplaySubject<districtsComboBox[]> = new ReplaySubject<districtsComboBox[]>(1);
  public filteredCity: ReplaySubject<comboBox[]> = new ReplaySubject<comboBox[]>(1);
  public filteredCertificateType: ReplaySubject<comboBox[]> = new ReplaySubject<comboBox[]>(1);
  public filteredRepresentativeCertificateType: ReplaySubject<comboBox[]> = new ReplaySubject<comboBox[]>(1);
  private _onDestroy = new Subject<void>();

  // Error message to display
  error = '';
  // Variable to subscribe to error
  subscription: Subscription;

  /**
   * Check if District hasn't Ward
   */
  notHasWard = false;

  // Refer to form in view
  @ViewChild('f', { static: false }) ngForm: NgForm;
  // Subscribe to form changing
  formChangesSubscription: Subscription;
  // Whether the form change or not
  isFormChanging = false;
  @ViewChildren('focusInput') focusInput;
  @ViewChild('certificateNoEl', { static: false }) certificateNoEl: ElementRef;
  @HostListener('submit')
  onFormSubmit() {
    const invalidElements = this.el.nativeElement.querySelectorAll('.mat-form-field-invalid .mat-input-element,.mat-select-invalid');
    if (invalidElements.length > 0) {
      invalidElements[0].focus();
    }
  }

  constructor(
    // public dialogRef: MatDialogRef<UpdateBranchComponent>,
    // @Inject(MAT_DIALOG_DATA) public data: any,
    private el: ElementRef,
    private branchService: BranchService,
    public commonService: CommonService,
    public datepipe: DatePipe,
    public notificationService: NotificationService,
    public dialog: MatDialog,
    private router: Router,
    private route: ActivatedRoute,
    private breadcrumbsService: BreadcrumbsService,
    public message: Message,
    private toastr: ToastrService,
    public customerFilter: CustomerFilterLanguage
  ) {
    super(commonService, message);
    this.branch.id = this.route.snapshot.paramMap.get('id');
  }

  /**
   * Get initial data
   */
  ngOnInit() {
    this.certificateTypeFilterCtrl.valueChanges.pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.commonService.filterCertificateType(this.certificateType, this.certificateTypeFilterCtrl, this.filteredCertificateType);
      });

    this.representativeCertificateTypeFilterCtrl.valueChanges.pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.commonService.filterCertificateType
          (this.representativeCertificateType,
            this.representativeCertificateTypeFilterCtrl,
            this.filteredRepresentativeCertificateType);
      });

    this.cityFilterCtrl.valueChanges.pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.commonService.filterCertificateType(this.cities, this.cityFilterCtrl, this.filteredCity);
      });

    this.districtsFilterCtrl.valueChanges.pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.commonService.filterCertificateType(this.selectedDistricts, this.districtsFilterCtrl, this.filteredDistricts);
      });

    this.wardFilterCtrl.valueChanges.pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.commonService.filterCertificateType(this.selectWards, this.wardFilterCtrl, this.filteredWard);
      });

    this.getCertificateType();
    this.getRepresentativeCertificateType();
    // this.loadCities();
    // this.loadDistricts();
    // this.loadWards();
    this.commonService.getCategory().subscribe(result => {
      this.cities = result[0].data;
      this.districts = result[1].data;
      this.wards = result[2].data;
      this.filteredCity.next(this.cities.slice());
      this.getBranch(this.branch.id);
    })
    this.notificationService.subscribeErrorService();
    window.scrollTo(0, 0);
    this.breadcrumbsService.store([
      { label: 'breadcrumbs.home', url: 'main', params: [], highlight: false },
      { label: 'breadcrumbs.enterprise_manage', url: '', params: [], highlight: false },
      { label: 'breadcrumbs.branch', url: 'branches', params: [], highlight: false },
      { label: 'breadcrumbs.branch_update', url: 'update-branch/:id', params: [this.branch.id], highlight: false },
    ]);

    this.subscription = this.route
      .queryParams
      .subscribe(params => {
        // Defaults to 0 if no query param provided.
        this.searchtenantId = params.tenantId || 0;
        this.searchPage = params.page || 0;
        this.searchPageSize = params.pageSize || 0;
        this.searchParentId = params.parentId || '';
        this.searchKeyword = params.keyword || '';
        this.searchStatus = params.status;
      });
  }

  ngAfterViewInit() {
    setTimeout(_ => this.focusInput.first.nativeElement.focus());
    this.formChangesSubscription = this.ngForm.form.statusChanges.subscribe(() => {
      if (this.ngForm.dirty || this.ngForm.touched) {
        this.isFormChanging = true;
      }
    });
  }

  /**
   * Implement ngOnDestroy method, unsubscribe error service to avoid memory leak
   */
  ngOnDestroy() {
    this.notificationService.unsubscribeErrorService();
    this.formChangesSubscription.unsubscribe();
  }

  /**
   * Get cities list from local storage or api
   */
  loadCities() {
    // if (localStorage.getItem('cities') === null) {
      this.commonService.getAllCityRedis().subscribe(rs => {
        const data = rs.data;
        if (data != null && data.length > 0) {
          this.cities = data;
          localStorage.setItem(
            'cities',
            JSON.stringify(this.cities),
          );
          this.filteredCity.next(this.cities.slice());
        }
      });
    // } else {
    //   this.cities = JSON.parse(
    //     localStorage.getItem('cities')
    //   );
    //   this.filteredCity.next(this.cities.slice());
    // }
  }

  /**
   * Get districts list from local storage or api
   */
  loadDistricts() {
    // if (localStorage.getItem('districts') === null) {
      this.commonService.getAllDistrictsRedis().subscribe(rs => {
        const data = rs.data;
        if (data != null && data.length > 0) {
          this.districts = data;
          localStorage.setItem(
            'districts',
            JSON.stringify(this.districts),
          );
        }
      });
    // } else {
    //   this.districts = JSON.parse(
    //     localStorage.getItem('districts')
    //   );
    // }
  }

  /**
   * Get wards list from local storage or api
   */
  loadWards() {
    // if (localStorage.getItem('wards') === null) {
      this.commonService.getAllWardRedis().subscribe(rs => {
        const data = rs.data;
        if (data != null && data.length > 0) {
          this.wards = data;
          localStorage.setItem(
            'wards',
            JSON.stringify(this.wards),
          );
        }
      });
    // } else {
    //   this.wards = JSON.parse(
    //     localStorage.getItem('wards')
    //   );
    // }
  }

  /**
   * Get parent branches for creating branch
   */
  getBranch(id: number) {
    this.branchService.getBranch(id).subscribe(
      rs => {
        if (rs == null || rs.data == null) {
          return 0;
        }
        this.branch = {
          ...this.branch,
          ...rs.data,
          issuedDate: rs.data.issuedDate != null ? new Date(rs.data.issuedDate) : null,
          representativeIssuedDate: rs.data.representativeIssuedDate != null ? new Date(rs.data.representativeIssuedDate) : null,
          birthday: rs.data.birthday != null ? new Date(rs.data.birthday) : null,
        };
        this.oldBranchName = rs.data.name;
        if (this.branch.addresses[0] === undefined || this.branch.addresses.length == 0) {
          this.branch.addresses[0] = {
            cityId: null,
            wardId: null,
            districtId: null,
            address: ''
          };
        } else {
          this.selectedDistricts = this.districts.filter(x => {
            return x.cityId == this.branch.addresses[0].cityId;
          });
          this.filteredDistricts.next(this.selectedDistricts.slice());
          this.selectWards = this.wards.filter(x => {
            return x.districtId == this.branch.addresses[0].districtId;
          });
          this.filteredWard.next(this.selectWards.slice());
        }
      }
    );
  }

  /**
   * Detect change on city or district combobox
   */
  onChange(value: number, opt: number = 1) {
    switch (opt) {
      case 1:
        this.selectedDistricts = this.districts.filter(x => {
          this.selectWards = null;
          this.branch.addresses[0].districtId = null;
          this.branch.addresses[0].wardId = null;
          return x.cityId == value;
        });
        this.filteredDistricts.next(this.selectedDistricts.slice());
        this.filteredWard = new ReplaySubject<wardsCombobox[]>(1);
        break;
      case 2:
        this.selectWards = this.wards.filter(x => {
          this.branch.addresses[0].wardId = null;
          return x.districtId == value;
        });
        this.filteredWard.next(this.selectWards.slice());
        if (this.selectWards.length === 0) {
          this.notHasWard = true;
        } else {
          this.notHasWard = false;
        }
        break;
      default:

        break;
    }
  }

  /**
   * On click button update branch
   */
  onUpdateBranch() {
    if (this.isFormChanging || this.uploadMultiFileComponent.isFormChanging) {
      const dialogRe = this.dialog.open(WarningComponent, {
        width: '350px',
        // Them ten chi nhanh
        data: this.commonService.format(this.message.getMessage('messages.confirm_update_branch'), this.oldBranchName)
      });

      dialogRe.afterClosed().subscribe(rs => {
        if (rs) {
          this.uploadMultiFileComponent.uploadFile((attachments) => {
            this.branch.attachments = attachments;
            this.updateBranch(dialogRe);
          }, () => {
            this.updateBranch(dialogRe);
          });
        }
      });
    } else {
      this.router.navigate(['/home-enterprise/branches'], {
        queryParams: {
          tenantId: this.searchtenantId,
          page: this.searchPage,
          pageSize: this.searchPageSize,
          parentId: this.searchParentId,
          keyword: this.searchKeyword,
          status: this.searchStatus
        }
      });
    }
  }



  /**
   * Call update branch service and push data to server.
   * @param dialogRe: Dialog result confirmation.
   */
  private updateBranch(dialogRe) {
    this.branchService.updateBranch(
      this.branch,
      () => {
        this.show = false;
        this.toastr.success(this.message.getMessage('messages.update_success'));
        this.router.navigate(['/home-enterprise/branches'], {
          queryParams: {
            tenantId: this.searchtenantId,
            page: this.searchPage,
            pageSize: this.searchPageSize,
            parentId: this.searchParentId,
            keyword: this.searchKeyword,
            status: this.searchStatus
          }
        });
      },
      () => {
        this.getBranch(this.branch.id);
      },
      this.onUpdateEnterpriseError.bind(this)
    );
  }

  private onUpdateEnterpriseError(rs: any) {
    if (!rs.success) {
      if (String(rs.code) === '0x00118') {
        this.certificateNoExistingHanlder(rs);
      } else {
        this.notificationService.notify(Utils.toErrorMessage(rs, this.message.getMessage('messages.error_message')));
      }
    }
  }

  private certificateNoExistingHanlder(rs: any): void {
    this.ngForm.form.controls.certificateNo.setErrors({ incorrect: true, duplicate: true });
    Utils.forcusAndScrollToElement(this.certificateNoEl);
  }


  /**
   * Close adding branch dialog
   */
  onNoClick() {
    if (this.isFormChanging || this.uploadMultiFileComponent.isFormChanging) {
      const dialogRe = this.dialog.open(WarningComponent, {
        width: '350px',
        data: this.message.getMessage('messages.confirm_change_data')
      });
      dialogRe.afterClosed().subscribe(rs => {
        if (rs) {
          this.show = false;
          // this.dialogRef.close();
          this.router.navigate(['/home-enterprise/branches'], {
            queryParams: {
              tenantId: this.searchtenantId,
              page: this.searchPage,
              pageSize: this.searchPageSize,
              parentId: this.searchParentId,
              keyword: this.searchKeyword,
              status: this.searchStatus
            }
          });
        }
        dialogRe.close();
      });
    } else {
      this.router.navigate(['/home-enterprise/branches'], {
        queryParams: {
          tenantId: this.searchtenantId,
          page: this.searchPage,
          pageSize: this.searchPageSize,
          parentId: this.searchParentId,
          keyword: this.searchKeyword,
          status: this.searchStatus
        }
      });
    }
  }

  /**
   * Confirm before navigation
   */
  canDeactivate() {
    const tenantId = localStorage.getItem('tenantId');
    if ((this.isFormChanging && this.show && tenantId != null)
      || (this.uploadMultiFileComponent.isFormChanging && this.show && tenantId != null)) {
      const dialogRe = this.dialog.open(WarningComponent, {
        width: '350px',
        data: this.message.getMessage('messages.confirm_change_data')
      });
      return dialogRe.afterClosed().pipe(map(result => {
        if (result) {
          return true;
        } else {
          return false;
        }
      }), first());
    } else {
      return true;
    }
  }

  /**
   * Get certificate list
   */
  getCertificateType() {
    this.commonService.getCertificateType().subscribe(rs => {
      if (rs && rs.data) {
        const result = rs.data;
        this.certificateType = result;
        this.filteredCertificateType.next(this.certificateType.slice());
      }
    });
  }

  /**
   * Get representative certificate list
   */
  getRepresentativeCertificateType() {
    this.commonService.getRepresentativeCertificateType().subscribe(rs => {
      if (rs && rs.data) {
        const result = rs.data;
        this.representativeCertificateType = result;
        this.filteredRepresentativeCertificateType.next(this.representativeCertificateType.slice());
      }
    });
  }

  onAttachmentChange(event) {
    this.isFormChanging = event;
  }
  getEnterpriseTypeOptions(options) {
    return this.customerFilter.filterOptionsData(options);
  }
}
